import React, { useState, useCallback } from "react";
import { useMsal } from "@azure/msal-react";
import { loginRequest } from "../config/authConfig";
import { Button } from "react-bootstrap";
import { LoginMethod } from "../types/auth.types";
import { AuthError } from "@azure/msal-browser";

const LoginButton: React.FC = () => {
  const { instance } = useMsal();
  const [loading, setLoading] = useState<boolean>(false);

  const handleLogin = useCallback(
    async (loginType: LoginMethod) => {
      if (loading) return;
      setLoading(true);
      try {
        if (loginType === "popup") {
          await instance.loginPopup(loginRequest);
        } else {
          await instance.loginRedirect(loginRequest);
        }
      } catch (error) {
        const authError = error as AuthError;
        if (authError.errorCode !== "interaction_in_progress") {
          console.error("Error en login:", authError.message);
        }
      } finally {
        setLoading(false);
      }
    },
    [instance, loading]
  );

  return (
    <div className="d-flex gap-2">
      <Button
        variant="success"
        onClick={() => handleLogin("popup")}
        size="sm"
        disabled={loading}
      >
        {loading ? "Iniciando..." : "Iniciar Sesión (Popup)"}
      </Button>
      <Button
        variant="outline-light"
        onClick={() => handleLogin("redirect")}
        size="sm"
        disabled={loading}
      >
        Iniciar Sesión (Redirect)
      </Button>
    </div>
  );
};

export default LoginButton;
